import { useMemo } from 'react';

const defaultExcludedKeys = ['_id', 'createdAt', 'updatedAt', 'isDeleted', '__v'];

export const usePDFTableConfig = ({
  data = [],
  customLabels = {},
  excludedKeys = defaultExcludedKeys,
  orientation = 'portrait',
  customRowsPerPage = null,
  customColumnOrder = [], // <-- Add this
}) => {
  const rowsPerPage = useMemo(() => {
    if (customRowsPerPage !== null) return customRowsPerPage;
    return orientation === 'landscape' ? 20 : 30;
  }, [orientation, customRowsPerPage]);

  const columns = useMemo(() => {
    const keys = Object.keys(data[0] || {});
    const filteredKeys = keys.filter(key => !excludedKeys.includes(key));

    let orderedKeys = [];

    if (customColumnOrder.length > 0) {
      // Respect custom order, ignore unknown keys
      orderedKeys = customColumnOrder.filter(key => filteredKeys.includes(key));
      // Add remaining keys not covered by custom order
      const remaining = filteredKeys.filter(key => !customColumnOrder.includes(key));
      orderedKeys = [...orderedKeys, ...remaining];
    } else {
      orderedKeys = filteredKeys;
    }

    return orderedKeys.map(key => ({
      label: customLabels[key] || key?.charAt(0)?.toUpperCase() + key?.slice(1),
      key,
    }));
  }, [data, customLabels, excludedKeys, customColumnOrder]);

  const pages = useMemo(() => {
    return Array.from({ length: Math.ceil(data.length / rowsPerPage) }, (_, i) =>
      data.slice(i * rowsPerPage, i * rowsPerPage + rowsPerPage)
    );
  }, [data, rowsPerPage]);

  return { columns, pages, rowsPerPage };
};
